import React, { useContext, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Form, Button, Checkbox } from "semantic-ui-react";
import { toast } from "react-toastify";
import {
  combineValidators,
  composeValidators,
  isRequired,
  hasLengthGreaterThan,
  hasLengthLessThan,
  matchesPattern,
} from "revalidate";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import TextInput from "../../../../app/common/form/TextInput";
import { IUsers, IUserAdmin } from "../../../../app/models/user";
import { observer } from "mobx-react-lite";

const validate = combineValidators({
  "user.name": composeValidators(
    isRequired({ message: "El Nombre es obligatorio" }),
    matchesPattern(/^[A-zÀ-ÿ -]*$/)({
      message:
        "Solo se permiten caracteres alfanuméricos",
    }),
    hasLengthLessThan(65)({
      message: "El Nombre debe tener máximo 64 caracteres",
    }),
    hasLengthGreaterThan(1)({
      message: "El Nombre debe tener al menos 2 caracteres",
    }),
  )(),
  "user.lastName": composeValidators(
    isRequired({ message: "El Apellido es obligatorio" }),
    matchesPattern(/^[A-zÀ-ÿ -]*$/)({
      message:
        "Solo se permiten caracteres alfanumérico",
    }),
    hasLengthLessThan(65)({
      message: "El Apellido debe tener máximo 64 caracteres",
    }),
    hasLengthGreaterThan(1)({
      message: "El Apellido debe tener al menos 2 caracteres",
    }),
  )(),
  "user.phone": composeValidators(
    isRequired({ message: "El Teléfono es obligatorio" }),
    matchesPattern(/^[a-zA-Z0-9.()-\\]*$/)({
      message:
        "Teléfono no válido. Contiene espacios o caracteres especiales diferente a: ( ) - . \\",
    }),
    hasLengthGreaterThan(6)({
      message: "El Teléfono debe tener al menos 7 caracteres",
    }),
    hasLengthLessThan(33)({
      message: "El Teléfono debe tener máximo 32 caracteres",
    })
  )(),
  "user.email": composeValidators(
    isRequired({ message: "El Email es obligatorio" }),
    matchesPattern(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/)({
      message: "Por favor digite un Email valido",
    }),
    hasLengthLessThan(257)({
      message: "El Email debe tener máximo 256 caracteres",
    }),
    hasLengthGreaterThan(5)({
      message: "El Email debe tener al menos 6 caracteres",
    }),
  )(),
});

interface IProps {
  user: IUsers;
  count: number;
}

const EditUserAdminForm: React.FC<IProps> = ({ user, count }) => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { editAdminUser } = rootStore.userAdminStore;
  const { loading } = rootStore.buttonLoadingStore;

  const [editUserAdminForm] = useState<IUserAdmin>({
    user: {
      username: user.username,
      name: user.name,
      lastName: user.lastName,
      phone: user.phone,
      email: user.email,
    },
  });
  const handleFinalFormSubmit = (values: any) => {
    if (count === 1 && user.isAdministrator) {
      values.isAdministrator = true;
    }

    if (
      values.user.email !== editUserAdminForm.user.email ||
      values.user.name !== editUserAdminForm.user.name ||
      values.user.lastName !== editUserAdminForm.user.lastName ||
      values.user.phone !== editUserAdminForm.user.phone ||
      values.isAdministrator !== user.isAdministrator
    ) {
      values.user.name = values.user.name.trim();
      values.user.lastName = values.user.lastName.trim();
      values.user.email = values.user.email.trim();
      values.user.phone = values.user.phone.trim();
      editAdminUser(user.id, values);
    } else toast.error("No ha hecho ningún cambio");
  };
  return (
    <div className="modalContent">
      <FinalForm
        validate={validate}
        initialValues={editUserAdminForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <label>Usuario de acceso</label>
              <Field
                name="user.username"
                disabled={true}
                value={editUserAdminForm.user.username}
                component={TextInput}
              />
              <label>Nombres</label>
              <Field
                name="user.name"
                value={editUserAdminForm.user.name}
                component={TextInput}
              />
              <label>Apellidos</label>
              <Field
                name="user.lastName"
                value={editUserAdminForm.user.lastName}
                component={TextInput}
              />
              <label>Teléfono</label>
              <Field
                name="user.phone"
                value={editUserAdminForm.user.phone}
                component={TextInput}
              />
              <label>Mail notificaciones</label>
              <Field
                name="user.email"
                value={editUserAdminForm.user.email}
                component={TextInput}
              />
              <div className="adminCheck">
                <label>Administrador</label>
                {user.isAdministrator && count === 1 ? (
                  <Field name="isAdministrator">
                    {(props) => (
                      <Form.Field className="adminCheck">
                        <Checkbox
                          name="isAdministrator"
                          readOnly
                          defaultChecked={user.isAdministrator}
                        />
                      </Form.Field>
                    )}
                  </Field>
                ) : (
                  <Field
                    name="isAdministrator"
                    component="input"
                    type="checkbox"
                    initialValue={user.isAdministrator}
                  />
                )}
              </div>
              <br />
              <br />
              <Button
                loading={loading}
                disabled={loading}
                className="ui primary button"
                color="blue"
                type="submit"
                content="Guardar"
              />
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(EditUserAdminForm);
